import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "sub-menu-arrow" }

import {ref} from "vue";
  import HMenuItem from "./h-menu-item.vue";
  
  import {Menu} from "./type";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'h-menu',
  props: {
    menuList: {},
    active: {}
  },
  setup(__props: any) {

  const props = __props;

  let isFold = ref<boolean>(false);
  let showMenu = ref<boolean>(true);

  const foldEvent = () => {
    isFold.value = !isFold.value;
    if (isFold.value) {
      showMenu.value = false;
    } else {
      setTimeout(() => {
        showMenu.value = true;
      }, 180);

    }
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sub-menu", {'retract': _unref(isFold)}])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuList, (item, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: item.id
      }, [
        (_unref(showMenu))
          ? (_openBlock(), _createBlock(HMenuItem, {
              key: 0,
              menu: item,
              active: _ctx.active
            }, null, 8, ["menu", "active"]))
          : _createCommentVNode("", true)
      ], 64))
    }), 128)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "fold",
        onClick: foldEvent
      }, [
        _createElementVNode("i", {
          class: _normalizeClass(["icon iconfont icon-icon_jiantou", {'rotate': !_unref(showMenu)}])
        }, null, 2)
      ])
    ])
  ], 2))
}
}

})